import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  name: {
    fontStyle: prop => (prop.isProductionStub ? 'normal' : 'italic'),
    color: prop => prop.isProductionStub && colors.grey2,
    fontSize: prop => prop.isProductionStub && fontSize.basic,
  },
  workItemOriginalName: {
    fontSize: fontSize.medium,
    fontWeight: 'bold',
    color: colors.darkText,
  },
  workItemName: {
    fontSize: prop => prop.isMultipleWorkItem && fontSize.smallTitle,
  },
  bold: {
    fontWeight: 'bold',
  },
}));

const OriginalName = ({ name, originalName, info, variant, isProductionStub, isMultipleWorkItem }) => {
  const classes = useStyles({ isProductionStub, isMultipleWorkItem });

  return (
    <>
      <span
        className={classnames(variant === 'bold' ? classes.bold : '', {
          [classes.workItemOriginalName]: isMultipleWorkItem,
        })}
      >
        {originalName || name || ''}
      </span>
      {name && originalName && originalName !== name && (
        <span className={classnames(classes.name, { [classes.workItemName]: isMultipleWorkItem })}>{` (${name})`}</span>
      )}
      {info && ` (${info})`}
    </>
  );
};

OriginalName.propTypes = {
  name: PropTypes.string,
  originalName: PropTypes.string,
  info: PropTypes.string,
  variant: PropTypes.oneOf(['bold']),
  isProductionStub: PropTypes.bool,
  isMultipleWorkItem: PropTypes.bool,
};

export default memo(OriginalName);
